// extracted by mini-css-extract-plugin
var _1 = "WxNdJO0lJfe_COSSTvlJ";
var _2 = "N9mRzaVRhTYvp1_RTtIy";
var _3 = "m84xU6UtpfWFSgbwDwrO";
var _4 = "fF0y4Ldoz1z3J7GsDJrQ";
var _5 = "ljCBnIFEzG7sYu6Sm3O2";
var _6 = "umeWuImoJRk7nhixujBr";
var _7 = "sQ5Mg0FWecukqbJVY_aQ";
var _8 = "uzQO2_Ov7rCI_fig6iK_";
var _9 = "Ud2n7x88E1Pl35CdmXp6";
var _a = "AU5kvj5t9sq3lc1x9pXR";
var _b = "Gsw_ZH3E5ElntCcmjVc3";
var _c = "zggvZLwTWidOWNPGtbke";
var _d = "Sc3LvJ2s3iqSyTlJVqak";
var _e = "P0Zcd9rhys39sy5T0qrw";
var _f = "hNtjp3hGoyhT512Ouc4x";
var _10 = "VAXjaev1aj44nBPgJjpa";
var _11 = "lUaR93KRhsYHyt5RSrVQ";
var _12 = "fmlEArx8VnbILjM46e0Y";
var _13 = "KxaUHXcCthMPHA2v4Wa1";
export { _1 as "article", _2 as "is-128x128", _3 as "is-16x16", _4 as "is-24x24", _5 as "is-32x32", _6 as "is-48x48", _7 as "is-64x64", _8 as "is-96x96", _9 as "theme-cardiology", _a as "theme-dermatology", _b as "theme-empty", _c as "theme-lab", _d as "theme-mentalHealth", _e as "theme-ophthalmology", _f as "theme-pulmonology", _10 as "theme-referall", _11 as "theme-sleep", _12 as "theme-white-theme", _13 as "theme-xyz" }
